import './DashboardExpertMode.styles.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ListBox } from 'primereact/listbox';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLoadDashboardNodes } from '../../../hooks/useLoadDashboardNodes';

const DashboardExpertMode: FC = () => {
  const navigate = useNavigate();
  const [dashboardDialogVisible, setDashboardDialogVisible] = useState(false);

  const dashboard = useLoadDashboardNodes();

  return (
    <>
      {dashboard[0].children.length > 0 && (
        <>
          <Button
            className="p-button-text p-button-rounded"
            icon="pi pi-list"
            tooltip="Dashboard"
            rounded
            text
            severity="secondary"
            onClick={() => setDashboardDialogVisible(true)}
            aria-label="dashboard"
          />
          <Dialog
            header="Dashboard"
            visible={dashboardDialogVisible}
            onHide={() => setDashboardDialogVisible(false)}
            className="DashboardExpertMode-Component"
            dismissableMask
          >
            <ListBox
              className="dashboard-listbox"
              options={dashboard[0].children}
              optionLabel="label"
              optionValue="id"
              dataKey="key"
              onChange={e => {
                if (e.value) {
                  navigate(e.value);
                  setDashboardDialogVisible(false);
                }
              }}
              itemTemplate={node => (
                <div className="dashboard-item">
                  <i className={node.icon} />
                  <span>{node.label}</span>
                </div>
              )}
            />
          </Dialog>
        </>
      )}
    </>
  );
};

export default DashboardExpertMode;
